import { useState, useEffect } from "react";
import axios from "axios";
import { useUserAuth } from "../context/UserAuthContext";

const Packages = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const { token, language } = useUserAuth();
  const [packages, setPackages] = useState([]);
  console.log('packages',packages)
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [vendors, setVendors] = useState([]);

  const packageFinder = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/manager/packages`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          vendor_id: selectedVendor || undefined,
        },
      });
      setPackages(res.data.packages);
    } catch (error) {
      console.log("error", error);
    }
  };

  const fetchVendors = async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/manager/vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVendors(res.data.vendors);
    } catch (err) {
      console.log("Error fetching vendors:", err);
    }
  };

  useEffect(() => {
    if (!token) return;
    packageFinder();
    fetchVendors();
  }, [token, selectedVendor]);

  // Count active and inactive packages
  const activeCount = packages.filter(p => p.status).length;
  const inactiveCount = packages.filter(p => !p.status).length;

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card shadow-lg border-0 rounded-3">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
                  <div>
                    <h3 className="mb-1 fw-bold" style={{ color: '#2c3e50' }}>
                      {language === "en" ? "Packages" : "पैकेज"}
                    </h3>
                    {packages.length > 0 && (
                      <div className="mt-2">
                        <span className="badge bg-success me-2 px-2 py-1 rounded-pill">
                          {language === "en" ? "Active" : "सक्रिय"}: {activeCount}
                        </span>
                        <span className="badge bg-danger px-2 py-1 rounded-pill">
                          {language === "en" ? "Inactive" : "निष्क्रिय"}: {inactiveCount}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <label className="fw-semibold text-muted">
                      {language === "en" ? "Filter by Vendor:" : "विक्रेता द्वारा फ़िल्टर करें:"}
                    </label>
                    <select
                      className="form-select rounded-pill px-3 py-2"
                      value={selectedVendor || ""}
                      onChange={(e) => setSelectedVendor(e.target.value || null)}
                      style={{
                        width: "220px",
                        borderColor: '#dee2e6',
                        backgroundColor: '#f8f9fa',
                        fontWeight: '500'
                      }}
                    >
                      <option value="">{language === "en" ? "All Vendors" : "सभी विक्रेता"}</option>
                      {vendors.map((v) => (
                        <option key={v.id} value={v.id}>
                          {v.business_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="table table-hover table-bordered shadow-sm rounded-3 overflow-hidden">
                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                      <tr className="text-center">
                        <th style={{ width: '70px', color: '#495057', fontWeight: '600' }}>#</th>
                        <th style={{ color: '#495057', fontWeight: '600' }}>Business Name</th>
                        <th style={{ color: '#495057', fontWeight: '600' }}>Package Name</th>
                        <th style={{ width: '120px', color: '#495057', fontWeight: '600' }}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {packages.length > 0 ? (
                        packages.map((item, index) => (
                          <tr key={index} className="align-middle" style={{ transition: 'all 0.3s ease' }}>
                            <td className="text-center fw-semibold">{index + 1}</td>
                            <td className="fw-medium">{item.vendor_name}</td>
                            <td>
                              <span className="fw-medium">{item.package_name}</span> &nbsp;
                              {
                                item.status && (
                            <a href={item?.package_link} target="_blank" rel="noreferrer">
                                    <i className="fa fa-link"></i>
                                  </a>
                                )
                              }
                                  
                            </td>
                            <td className="text-center">
                              <span
                                className={`badge px-3 py-2 rounded-pill fs-7 ${
                                  item.status ? "bg-success" : "bg-danger"
                                }`}
                                style={{ fontSize: '0.75rem', fontWeight: '500' }}
                              >
                                {item.status 
                                  ? (language === "en" ? "Active" : "सक्रिय") 
                                  : (language === "en" ? "Inactive" : "निष्क्रिय")}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-5">
                            <div className="text-muted">
                              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📦</div>
                              <p className="mb-0">
                                {language === "en" 
                                  ? "No packages found" 
                                  : "कोई पैकेज नहीं मिला"}
                              </p>
                              <small className="text-muted">
                                {language === "en"
                                  ? "Try changing the vendor filter"
                                  : "विक्रेता फ़िल्टर बदलने का प्रयास करें"}
                              </small>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {packages.length > 0 && (
                  <div className="mt-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="text-muted">
                      <small>
                        {language === "en" 
                          ? `Showing ${packages.length} package${packages.length > 1 ? 's' : ''}` 
                          : `${packages.length} पैकेज${packages.length > 1 ? '' : ''} दिखा रहे हैं`}
                      </small>
                    </div>
                    <div className="d-flex gap-2">
                      <span className="badge bg-light text-success px-2 py-1 rounded-pill border border-success">
                        ✓ {language === "en" ? "Active" : "सक्रिय"}: {activeCount}
                      </span>
                      <span className="badge bg-light text-danger px-2 py-1 rounded-pill border border-danger">
                        ✗ {language === "en" ? "Inactive" : "निष्क्रिय"}: {inactiveCount}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .table-hover tbody tr:hover {
          background-color: #f8f9fa;
          transform: scale(1.01);
          transition: all 0.3s ease;
          cursor: pointer;
        }
        
        .table {
          margin-bottom: 0;
        }
        
        .form-select:focus {
          border-color: #86b7fe;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
        
        .badge {
          font-weight: 500;
          letter-spacing: 0.3px;
        }
        
        @media (max-width: 768px) {
          .d-flex {
            flex-direction: column;
            align-items: flex-start !important;
          }
          
          .table th, .table td {
            font-size: 0.875rem;
            padding: 0.5rem;
          }
          
          .badge {
            font-size: 0.7rem;
          }
        }
        
        @media (max-width: 1200px) {
          .table th, .table td {
            white-space: nowrap;
          }
        }
      `}</style>
    </div>
  );
};

export default Packages;